const modules = {
    title: String("Modules"),
    moduleManagerTitle: String("Management of my modules"),
    moduleNameHeader: String("Name"),
    moduleModifyModule: String("Actions"),
    modulePlotHeader: String("Assigned plot"),
    moduleEnabledHeader: String("Status"),
    moduleTypeHeader: String("Type"),
    moduleInstallationDateHeader: String("Installation date"),
    moduleParametersHeader: String("Parameters"),
    editButton: String("Modify"),
    editParamsButton: String("See/update"),
    newModuleButton: String("Add new module"),
    moduleParamModalTitle: String("Module parameters of {name}"),
    updateParams: String("Update parameters"),
    restoreParams: String("Restore parameters"),
    cancelButton: String("Cancel"),
    module_post_flow_meter_trees: String("Post-flowmeter trees"),
    module_soil_moisture_max_optimal_region_percentage: String("Field capacity"),
    module_soil_moisture_min_optimal_region_percentage: String("Permanent wilting point"),
    module_soil_moisture_shallow_depth: String("Soil moisture sensor in shallow depth"),
    module_soil_moisture_intermediate_depth: String("Soil moisture sensor in intermediate depth"),
    module_soil_moisture_greater_depth: String("Soil moisture sensor on a greater depth"),
    module_enabled: String("Sensor status"),
    module_depth: String("Sensor depth (cm)"),
    module_distance_to_dropper: String("Distance to dropper (cm)"),
    module_max: String("Maximum soil moisture sensor value"),
    module_min: String("Minimum soil moisture sensor value"),
    module_post_flow_meter_treesInfoPopover: String("Post-flowmeter trees"),
    module_soil_moisture_max_optimal_region_percentageInfoPopover: String("Field capacity expressed in percentage"),
    module_soil_moisture_min_optimal_region_percentageInfoPopover: String("Permanent wilting point expressed in percentage"),
    module_soil_moisture_shallow_depthInfoPopover: String("Soil moisture sensor in shallow depth"),
    module_soil_moisture_intermediate_depthInfoPopover: String("Soil moisture sensor in intermediate depth"),
    module_soil_moisture_greater_depthInfoPopover: String("Soil moisture sensor on a greater depth"),
    module_enabledInfoPopover: String("Sensor status"),
    module_depthInfoPopover: String("Sensor depth (cm)"),
    module_distance_to_dropperInfoPopover: String("Distance to dropper (cm)"),
    module_maxInfoPopover: String("Maximum soil moisture sensor value"),
    module_minInfoPopover: String("Minimum soil moisture sensor value"),
    moduleModalTitle: String("Modify module data"),
    moduleName: String("Module name"),
    moduleNameInfoPopover: String("Module name"),
    moduleNamePlaceholder: String("Name..."),
    modulePlot: String("Associated plot"),
    modulePlotInfoPopover: String("Plot in which the module is mounted"),
    moduleEnable: String("Module status"),
    moduleEnableInfoPopover: String("Module status"),
    moduleInstallationDate: String("Installation date"),
    moduleInstallationDateInfoPopover: String("Date on which the installation was carried out"),
    update: String("Update"),
    restoreModule: String("Restore"),
    errorFieldRequired: String("This field is required"),
    errorInvalidLength: String("The size of the field must be minimum of {length} characters"),
    errorNameAlreadyExists: String("This name already exists."),
    newModuleModalTitle: String("New Module Form"),
    moduleActivationCode: String("Module code or QR"),
    moduleActivationCodePlaceholder: String("Enter the module code here"),
    moduleActivationCodeInfoPopover: String("The module code comes on the identification label of the module. Likewise, if there is a QR code on this label, you can scan it so that the code is introduced automatically."),
    moduleLatitudeLongitude: String("Module location"),
    currentLocationButton: String("Current location"),
    moduleLatitudeLongitudeInfoPopover: String("Location of the module in degrees with the following format"),
    moduleLatitudePlaceholder: String("Latitude"),
    moduleLongitudePlaceholder: String("Longitude"),
    createButton: String("Create module"),
    errorActivationCodeRegex: String("The format of the code introduced is invalid."),
    moduleLocationHeader: String("Location"),
    modulePlotDefault: String("Select a plot ..."),
    moduleErrorActivationCodeNotAllowed: String("This activation code has already been used."),
    moduleErrorNotFound: String("This activation code does not belong to any station."),
    moduleErrorPlotNotSelected: String("No plot has been selected."),
    moduleCurrentStatus: String("Details"),
    moduleStatusButton: String("Watch"),
    moduleStatusModalTitle: String("Station details"),
    moduleStatusModuleName: String("Station"),
    moduleStatusStatus: String("Actual state"),
    moduleStatusGood: String("Proper functioning"),
    moduleStatusWarning: String("It works with errors"),
    moduleStatusError: String("It does not respond"),
    moduleStatusUpdateButton: String("To update"),
    moduleStatusLastMeasureDate: String("Date of the last shipment received"),
    moduleStatusMeasureNameHeader: String("Sensor"),
    moduleStatusProcessedHeader: String("Processed data"),
    moduleStatusRawHeader: String("Raw data"),
    moduleStatus_battery_voltage: String("Battery voltage"),
    moduleStatus_soil_1_meter: String("Soil 1"),
    moduleStatus_soil_2_meter: String("Soil 2"),
    moduleStatus_soil_3_meter: String("Soil 3"),
    moduleStatus_leaf_meter: String("Leaf humidity"),
    moduleStatus_hum_meter: String("RH"),
    moduleStatus_temp_meter: String("Room temperature"),
    moduleStatus_rain_meter: String("Pluviometer"),
    moduleStatus_gauge_meter: String("Caudalimetro"),
    moduleStatusErrorHeader: String("Error list"),
    moduleStatusErrorCode: String("Code"),
    moduleStatusErrorComponent: String("Component"),
    moduleStatusErrorTimes: String("Times"),
    moduleNotPlotAllocated: String("Not assigned"),
};

export default modules;